/**
 * @generated SignedSource<<b6f80d59f146e9811d439b05efc96d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTodoEditMoreMenuItems_todo$data = {
  readonly id: string;
  readonly isOrg: boolean;
  readonly title: string;
  readonly " $fragmentType": "useTodoEditMoreMenuItems_todo";
};
export type useTodoEditMoreMenuItems_todo$key = {
  readonly " $data"?: useTodoEditMoreMenuItems_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTodoEditMoreMenuItems_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTodoEditMoreMenuItems_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "300d683999cd29d80dc3765b67def4b7";

export default node;
